"use strict";
/*!
 * @ganache/filecoin-options
 *
 * @author Tim Coulter
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilecoinDefaults = exports.FilecoinOptionsConfig = void 0;
const src_1 = require("./src");
var src_2 = require("./src");
Object.defineProperty(exports, "FilecoinOptionsConfig", { enumerable: true, get: function () { return src_2.FilecoinOptionsConfig; } });
Object.defineProperty(exports, "FilecoinDefaults", { enumerable: true, get: function () { return src_2.FilecoinDefaults; } });
exports.default = {
    FilecoinDefaults: src_1.FilecoinDefaults,
    FilecoinOptionsConfig: src_1.FilecoinOptionsConfig
};
//# sourceMappingURL=index.js.map